import React, { Fragment } from 'react';

interface OnboardingSuccessProps {
  submit: () => void;
}

const StudentBooksCompleted: React.FC<OnboardingSuccessProps> = ({ submit }) => {
  return (
    <>
      <div className="bg-white max-w-lg font-sofiaSans">
        <div className="text-start">
          <h2 className="text-3xl font-bold text-center text-black mb-5">You're All Out of Books!</h2>
          <div className="mt-2">
            <p className="text-base text-gray-600 leading-relaxed px-2 mb-3 text-center">You’ve finished all your books for now.</p>
            <p className="text-base text-gray-600 leading-relaxed px-2 mb-3 text-center md:px-16">
              📚 Ask your teacher to add a new book to your account so you can keep going!
            </p>
          </div>
        </div>
      </div>
      <div className="bg-white py-2 flex justify-center items-center">
        <button
          className={`px-6 py-2 h-9 bg-secondaryStoryAdditionalLightBlueText text-whiteText font-bold leading-none rounded-2xl hover:shadow-md transition-shadow flex items-center`}
          onClick={() => submit()}
        >
          Ok
        </button>
      </div>
    </>
  );
};

export default StudentBooksCompleted;
